export default [
  {
    path: "/xwsxhInternetv1", // 无视频
    name: "xwsxhInternetv1",
    meta: {
      title: "视宣号精英版",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/xwsxhtf/xwsxhInternetv1")
  },
  {
    path: "/wytgsxhInternetv1", // 无视频
    name: "wytgsxhInternetv1",
    meta: {
      title: "视宣号精英版",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/xwsxhtf/xwsxhInternetv1")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/xwsxhInternet.js